var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _PROJECT_TYPES$CODING, _PROJECT_TYPES$CODING2, _PROJECT_TYPES$CODING3, _GamepadExampleProjec;

var _require = require('./constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    HARDWARE_TYPES = _require.HARDWARE_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES,
    GAMEPAD_TYPES = _require.GAMEPAD_TYPES;

var exampleJS = require('./codingProjects/hardwareJS/exampleJS.json');

var examplePY = require('./codingProjects/hardwarePY/examplePY.json');

var ScratchEbotEmptyProject = 'ScratchEbotEmptyProject';
var ScratchMatrixSimEmptyProject = 'ScratchMatrixSimEmptyProject';
var ScratchLedSimEmptyProject = 'ScratchLedSimEmptyProject';
var ScratchEbotSimEmptyProject = 'ScratchEbotSimEmptyProject';
var ScratchConveyorParcelSorterProject = 'ScratchConveyorParcelSorterProject';
var ScratcheBotObstacleAvoidProject = 'ScratcheBotObstacleAvoidProject'; //Only project is Remote Control
//Gamepad Type -> Project Type -> Block Level -> scratch|webappJS

var GamepadExampleProjects = (_GamepadExampleProjec = {}, _defineProperty(_GamepadExampleProjec, GAMEPAD_TYPES.xbox, _defineProperty({}, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING = {}, _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.BEGINNER, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.CORE, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.ADVANCED, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _PROJECT_TYPES$CODING))), _defineProperty(_GamepadExampleProjec, GAMEPAD_TYPES.t3, _defineProperty({}, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING2 = {}, _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.BEGINNER, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.CORE, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.ADVANCED, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _PROJECT_TYPES$CODING2))), _defineProperty(_GamepadExampleProjec, GAMEPAD_TYPES.retro, _defineProperty({}, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING3 = {}, _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.BEGINNER, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.CORE, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.ADVANCED, {
  scratch: {
    scratchProject: ScratchEbotEmptyProject,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappJS: {
    codingProject: exampleJS,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  },
  webappPY: {
    codingProject: examplePY,
    projectVideoId: 'dv6etKxr',
    projectResourcesLink: 'https://google.com',
    projectInfo: 'Some help info here'
  }
}), _PROJECT_TYPES$CODING3))), _GamepadExampleProjec);
module.exports = {
  GamepadExampleProjects: GamepadExampleProjects
};